import React, { useEffect, useRef, memo, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useOnUpdate } from 'js/customHooks'
import "styles/main/Charts.sass"
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { fetchPlots } from 'js/fetchers'



export default function Charts() {
  const {zone, universe, parameter, dataset,product,geoArea,depth, stats, urls} = useSelector((state) => state);
  const dispatch = useDispatch();

  const region = () => geoArea == 'full-domain' ? zone+'-full-domain' : geoArea 

  useEffect(() => { 
     if (urls.length == 0)
      console.log('render Charts')
    else
      console.log('fetch Charts')
  });

  /*useEffect(() => { 
    if (stats != undefined)
    Promise.all(stats.map(stat => {
      const args = {
        "area": zone,
        "universe": universe,
        "variable": parameter,
        "dataset": dataset,
        "product": product,
        "subarea": zone == "medsea" && geoArea == "full-domain" ? "mediterranean-sea" : geoArea,
        "depth": depth,
        "stat": stat.name,
        "plot_type": "timeseries"
      }
      return fetchPlots(args)
    })).then(data => { 
      Promise.all(data.map(d => d.json())).then(data => {
        dispatch({ type: 'SET_URLS', payload: data.map(c => {return process.env.REACT_APP_CHART_URL + c.filename})});
      })
    })
  }, [zone, universe, parameter, dataset,product,geoArea,depth, stats]);

 //if (urls.length == 0) return <p>Loading...</p>;*/

//              {urls.map((c) => (
//                <img src={c} />
//              ))}
  return (
      <div id="metricsCharts">
        <SimpleBar autoHide={false} style={{ height: "100%" }}>
            <div id="charts">
              <iframe class="dynChart" src={"https://pqd.mercator-ocean.fr/charts/class4.html?region="+region()+"&product="+product+"&parameter="+parameter+"&layer="+depth+"&tipo=mean&dataset="+dataset}/>
              <iframe class="dynChart" src={"https://pqd.mercator-ocean.fr/charts/class4.html?region="+region()+"&product="+product+"&parameter="+parameter+"&layer="+depth+"&tipo=rmsd&dataset="+dataset}/>
              <iframe class="dynChart" src={"https://pqd.mercator-ocean.fr/charts/class4.html?region="+region()+"&product="+product+"&parameter="+parameter+"&layer="+depth+"&tipo=correlation&dataset="+dataset}/>
          </div>
        </SimpleBar>
      </div>
    )
}